var map = {
	"./bg.json": [
		"J6QZ",
		5
	],
	"./de-DE.json": [
		"46Zr",
		6
	],
	"./en-US.json": [
		"Gk0g",
		7
	],
	"./fr-FR.json": [
		"RUOV",
		8
	],
	"./pl.json": [
		"6Blx",
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5ey7";
module.exports = webpackAsyncContext;